module.exports = __webpack_public_path__ + "img/ko.c99c206b.svg";